module.exports = __webpack_public_path__ + "static/media/usernight.585657b7.png";